import { css } from '@/styled-system/css';

export const toastActionStyles = css.raw({
  marginInlineStart: 'default',
});
